import './pusher';
import '@/scss/app.scss';

// vue & inertia imports
import { createApp, h } from 'vue';
import { createInertiaApp, Link, Head } from '@inertiajs/vue3';

// i18n and localization
import i18n, { setLocale } from './i18n';

// State
import createPiniaRoot from './store';
import { useThemeStore } from './store/theme';

import Notifications from "@kyvg/vue3-notification";
import PortalVue from "portal-vue"
import VueSweetalert2 from "vue-sweetalert2";
import VueTelInput from "vue3-tel-input";
import VueTippy from "vue-tippy";
import FloatingVue from "floating-vue";
import VueClickAway from "vue3-click-away";
import * as Sentry from "@sentry/vue";

// global components and utility functions
import { registerGlobalComponents } from './global-components';
import route from "./utils/route"
// import { registerUtils } from './utils'

window.Pusher && (Pusher.logToConsole = (import.meta.env.VITE_APP_ENV !== 'production'))
const appName = import.meta.env.VITE_APP_NAME || 'Waspito AI';

createInertiaApp({
  title: title => title ? `${title} | ${appName}` : `${appName}`,
  progress: {delay: 250, color: "#2fa74b", showSpinner: true},
  resolve: name => {
    const pages = import.meta.glob('./pages/**/*.vue')
    const page = pages[`./pages/${name}.vue`]
      if (!page) {
         throw new Error(`Page not found: ${name}`)
      }
    return page()
  },
  setup({ el, App, props, plugin }) {
      const currentLocale = props.initialPage.props.app_locale || 'en';
      setLocale(currentLocale);

      const app = createApp({ render: () => h(App, props) })

      // Inertia core
      app.use(plugin)
      app.component('inertia-link', Link)
      app.component('inertia-head', Head)

      // i18n
      app.use(i18n)

      // routes
      app.config.globalProperties.route = route

      // Global helpers you previously added via mixin
      // registerUtils(app)

      // Pinia (store)
      const pinia = createPiniaRoot()
      const theme = useThemeStore(pinia)

      app.mixin({
          mounted() {
              theme.applyHtmlClass()
          },
      })

      // Third-party plugins (Vue 3)
      app.use(Notifications)
      app.use(VueSweetalert2)
      app.use(VueTelInput)
      app.use(VueClickAway)
      app.use(PortalVue)
      app.use(VueTippy, { directive: 'tippy', component: 'tippy' })
      app.use(FloatingVue, {
          themes: {
              dropdown: { placement: 'bottom' },
          },
      })

      // Your global components (auto-registered / async)
      registerGlobalComponents(app)

      // Sentry (Vue 3 requires passing the app)
      Sentry.init({
          app,
          dsn: import.meta.env.VITE_SENTRY_LARAVEL_DSN,
          // add integrations if you like
          // integrations: [Sentry.browserTracingIntegration()],
          environment: import.meta.env.VITE_APP_ENV|| 'local',
      })

      app.mount(el)
  },
})

if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('/sw.js')
            .then(reg => {})
            .catch(err => {});
    });
}